import { normalize, schema } from 'normalizr'
import { IHolidayItem } from '../types/index'
import { serverApi } from '../utils/request'

class HolidaysService {
  private urlBase = '/api/v1/services'
  private schemaServiceHolidays = new schema.Entity('serviceHolidays')
  public async fetchHolidays(serviceId: string): Promise<any> {
    const result = await serverApi.get(`/api/v1/serviceHoliday/${serviceId}`)
    const { entities } = normalize(result.data, [this.schemaServiceHolidays])
    if (!entities.serviceHolidays) {
      return {}
    }
    return entities.serviceHolidays
  }

  public updateHolidays(serviceId: string, serviceHolidays: IHolidayItem[]): Promise<any> {
    return serverApi
      .put(`${this.urlBase}/doUpdateOneWithServiceHolidays`, {
        serviceId,
        serviceHolidays
      })
      .then(
        response => response.data,
        error => {
          throw error.data
        }
      )
  }

  public async removeHoliday(id: string) {
    return await serverApi.delete(`/api/v1/serviceHoliday/${id}`)
  }
}

const holidaysService = new HolidaysService()

export { holidaysService }



// WEBPACK FOOTER //
// ./src/services/Holidays.ts